import { Injectable } from '@angular/core';
import { NavigationEnd, Router, ActivatedRoute} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AccountTabs } from '../types';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  public previousUrl = '';
  private currentUrl: string;

  constructor(private router: Router, private translate: TranslateService, private route: ActivatedRoute) {
    this.router.events.subscribe((event) => {
      this.currentUrl = this.router.url ? this.router.url : '';
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      }
    });
  }

  public navigateToHomepage() {
    const queryParams = { ...this.route.snapshot.queryParams };
    delete queryParams['aberg_user'];
    this.router.navigate([''], { queryParams });
  }

  public changeLanguageInCurrentRoute(language: string) {
    const url = `/${language}${this.router.url.slice(3)}`;
    this.router.navigateByUrl(url);
  }

  public navigateToLogin() {
    const queryParams = { ...this.route.snapshot.queryParams };
    delete queryParams['code'];
    delete queryParams['state'];
    delete queryParams['error'];
    delete queryParams['error_description'];
    this.router.navigate([this.translate.currentLang, 'auth', 'login'], {
      queryParams,
    });
  }

  public navigateToInternetExplorer() {
    this.router.navigate([this.translate.currentLang, 'internet-explorer']);
  }

  public navigateToError(queryParams?) {
    if (queryParams) {
      this.router.navigate(
        [this.translate.currentLang, 'error'],
        queryParams ? { queryParams } : undefined,
      );
    } else {
      this.router.navigate([this.translate.currentLang, 'error']);
    }
  }

  public navigateToMobile() {
    this.router.navigate([this.translate.currentLang, 'mobile']);
  }

  public navigateToMobileAccountActivation(queryParams?) {
    this.router.navigate(
      [this.translate.currentLang, 'mobile', 'accountactivation'],
      queryParams ? { queryParams } : undefined,
    );
  }

  public navigateToAccountActivation(queryParams?) {
    this.router.navigate(
      [this.translate.currentLang, 'auth', 'accountactivation'],
      queryParams ? { queryParams } : undefined,
    );
  }

  public navigateToMobileRegister(queryParams?) {
    this.router.navigate(
      [this.translate.currentLang, 'mobile', 'register'],
      queryParams ? { queryParams } : undefined,
    );
  }

  public navigateToCancelSubscription(queryParams?) {
    this.router.navigate(
      [this.translate.currentLang, 'auth', 'cancelsubscription'],
      queryParams ? { queryParams } : undefined,
    );
  }

  public navigateToMobileCancelSubscription(queryParams?) {
    this.router.navigate(
      [this.translate.currentLang, 'mobile', 'register'],
      queryParams ? { queryParams } : undefined,
    );
  }

  public navigateToRegister() {
    this.router.navigate([this.translate.currentLang, 'auth', 'register'], {
      queryParamsHandling: 'preserve',
    });
  }

  public navigateToProjects() {
    this.router.navigate(
      [
        this.translate.currentLang,
        'account',
        'projects',
        {
          outlets: {
            loads: null,
            profile: null,
            loadingspaces: null,
            subscription: null,
            invoices: null,
            contact: null,
            integration: null,
          },
        },
      ],
      { queryParamsHandling: 'preserve' },
    );
  }

  public navigateToMobileLogin() {
    this.router.navigate([this.translate.currentLang, 'mobile', 'login']);
  }

  public navigateToAccountTab(tab: AccountTabs) {
    this.router.navigate([this.translate.currentLang, 'account', tab], {
      queryParamsHandling: 'preserve',
    });
  }

  public navigateToSubscription() {
    this.router.navigate([this.translate.currentLang, 'account', 'subscription'], {
      queryParamsHandling: 'preserve',
    });
  }

  public navigateToContact() {
    this.router.navigate([this.translate.currentLang, 'account', 'contact'], {
      queryParamsHandling: 'preserve',
    });
  }

  public navigateToProfile(withEditForm: boolean) {
    this.router.navigate([this.translate.currentLang, 'account', 'profile'], {
      queryParamsHandling: 'preserve',
      state: { withEditForm },
    });
  }

  public navigateToAccountNotActive() {
    this.router.navigate([this.translate.currentLang, 'auth', 'accountnotactive']);
  }

  public navigateToOwnerChange(queryParams?) {
    this.router.navigate(
      [this.translate.currentLang, 'auth', 'ownerchange'],
      queryParams ? { queryParams } : undefined,
    );
  }

  public navigateToMobileOwnerChange(queryParams?) {
    this.router.navigate(
      [this.translate.currentLang, 'mobile', 'ownerchange'],
      queryParams ? { queryParams } : undefined,
    );
  }

  public navigateToOwnerChangeAccept(queryParams?) {
    this.router.navigate(
      [this.translate.currentLang, 'auth', 'ownerchangeaccept'],
      queryParams ? { queryParams } : undefined,
    );
  }

  public navigateToMobileOwnerChangeAccept(queryParams?) {
    this.router.navigate(
      [this.translate.currentLang, 'mobile', 'ownerchangeaccept'],
      queryParams ? { queryParams } : undefined,
    );
  }
}
